import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const uploadDocument = (request) => {
    const formData = new FormData();
    formData.append('FloorPlan', request.FloorPlan);
    formData.append('IsTemporary', 'true');
    return vdkEmHappinessPortalApi.post('/vdk-event-documents/create-floor-map', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
const getAllEventAttachments = (request) => {
    return vdkEmHappinessPortalApi.get(`/vdk-event-documents/${request.eventId}/get-all`, {
        params: {
            pageNumber: request.pageNumber,
            pageSize: request.pageSize,
            sortBy: request.sortBy,
            sortOrder: request.sortOrder
        }
    });
};
const createEventAttachment = (request) => {
    const formData = new FormData();
    formData.append('EventId', request.eventId);
    formData.append('FileTitle', request.fileTitle);
    formData.append('Type', String(request.type));
    formData.append('File', request.file);
    return vdkEmHappinessPortalApi.post('/vdk-event-documents/create-attachment', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
const deleteEventAttachment = (request) => {
    return vdkEmHappinessPortalApi.delete(`/vdk-event-documents/delete-attachment/${request.id}`);
};
const getDocumentDownloadUrl = (id) => {
    return vdkEmHappinessPortalApi.get(`/vdk-event-documents/get-document-download-url/${id}`);
};
const uploadEventStoryImage = (eventId, file) => {
    const formData = new FormData();
    formData.append('EventId', eventId);
    formData.append('File', file);
    return vdkEmHappinessPortalApi.post('/vdk-event-documents/upload-event-story-image', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
const uploadThankYouImage = (eventId, file) => {
    const formData = new FormData();
    formData.append('EventId', eventId);
    formData.append('File', file);
    return vdkEmHappinessPortalApi.post('/vdk-event-documents/upload-thank-you-image', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
const VDKEventDocumentAPI = {
    uploadDocument,
    getAllEventAttachments,
    createEventAttachment,
    deleteEventAttachment,
    getDocumentDownloadUrl,
    uploadEventStoryImage,
    uploadThankYouImage
};
export default VDKEventDocumentAPI;
